import { render } from "./FeedbackButton.vue?vue&type=template&id=ac1ee56c"
import script from "./FeedbackButton.vue?vue&type=script&lang=js"
export * from "./FeedbackButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__